import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaStoreUtility from "global/sparta-store-utility";







const defaults = {
  "userAgent": null,
  "showMessage": true, 
  "useAjax": false, 
  "debug": false, 
  "testMode": false, 
  "isLocal": (spartaStoreUtility.getData("environment") === "LOCAL"),
  "useSessionStorage": spartaStoreUtility.getData("useSessionStorage"), 
  "ua": "",
  "platform": "",
  "boaBrowserShowNoticeCookie": "",
  "boaBrowserTestCookie": ""
}

const EVENTS = {
  "LOADED": "LOADED.SpartaBrowserSupportUtility"
};

const VERSIONS = {
  BLOCKED_IE: 6,
  BLOCKED_FF: 2,
  EOL_IE: 10,
  EOL_CHROME: 55,
  EOL_FF: 50,
  EOL_SAFARI: 9
};

let instance;





class SpartaBrowserSupportUtility {





  constructor(options = {}) {
    if (!instance) {
      try {

        this.settings = $.extend({}, defaults, options);

        this._debug("browserDetect: begin browserDetect init");


        this.settings.useSessionStorage = this.settings.userAgent ? false : this.settings.useSessionStorage;
        this.settings.ua = this.settings.userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
        this.settings.platform = (typeof navigator !== 'undefined' ? navigator.platform : '');
        this.settings.boaBrowserShowNoticeCookie = spartaGlobalFunctions.spartaGetCookie("boaBrowserShowNotice");


        this.settings.boaBrowserTestCookie = spartaGlobalFunctions.spartaGetCookie("boaBrowserTest");

        if (!!this.settings.boaBrowserTestCookie) {
          this.settings.testMode = true;
        }


        if (this.settings.testMode) {
          this.settings.debug = true; 
          this.settings.showMessage = true; 
          this.settings.useSessionStorage = false; 
          this._debug('browserDetect: testMode is: ' + this.settings.testMode);
        }


        this.boaBrowserObject = this._boaBrowserGetSessionStorage();


        if (this.boaBrowserObject && this.boaBrowserObject.browserSupport) {


          this._boaBrowserShowMessage();


          this.boaBrowserObject.loaded = true;

          spartaEventsUtility.pub(EVENTS.LOADED);


        } else {


          let boaBrowserDefault = this._boaBrowserGetDefaultObj();


          let bowser = this._bowserUtil(this.settings.ua);


          this.boaBrowserObject = $.extend(true, boaBrowserDefault, bowser);


          this._boaBrowserSystemCheck();


          this._boaBrowserPluginCheck();


          this._boaBrowserUpdateMessageData();

        }
      } catch (e) {
        this._debug('browserDetect: _initialize error: ' + e);
      }












      this._debug("browserDetect: end browserDetect init");
      this._debug("this.boaBrowserObject");
      this._debug(this.boaBrowserObject);
      spartaStoreUtility.addData("browser", this.boaBrowserObject);

      instance = this;
    } else {
      return instance;
    }

  }

  get EVENTS() {
    return EVENTS;
  }


  hideBrowserAlert() {
    this._debug('begin hideBrowserAlert()');
    this.settings.showMessage = false;
  }


  _debug(msg) {
    if (window.console && this.settings.debug) {
      console.log(msg);
    }
  }



  _bowserUtil(ua) {






    let t = true;

    function detect(ua) {

      function getFirstMatch(regex) {
        let match = ua.match(regex);
        return (match && match.length > 1 && match[1]) || '';
      }

      let iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
        likeAndroid = /like android/i.test(ua),
        android = !likeAndroid && /android/i.test(ua),
        silk = /silk/i.test(ua),
        sailfish = /sailfish/i.test(ua),
        tizen = /tizen/i.test(ua),
        webos = /(web|hpw)os/i.test(ua),
        windowsphone = /windows phone/i.test(ua),
        edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i),
        versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
        tablet = /tablet/i.test(ua),
        mobile = !tablet && /[^-]mobi/i.test(ua),
        windows = !windowsphone && /windows/i.test(ua),
        mac = !iosdevice && !silk && /macintosh/i.test(ua),
        linux = !android && /linux/i.test(ua),
        result;

      if (/googlebot|bingbot|ysearch\/slurp|facebookexternalhit|twitterbot|BofASpider/i.test(ua)) {
        result = {
          name: 'Crawler/Bot',
          crawler: t,
        };
      } else if (/opera|opr/i.test(ua)) {
        result = {
          name: 'Opera',
          opera: t,
          version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
        };
      } else if (windowsphone) {
        result = {
          name: 'Windows Phone',
          vendor: "Microsoft",
          windowsphone: t,
          msie: t
        }
        if (edgeVersion) {
          result.msedge = t
          result.version = edgeVersion
        } else {
          result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
        }
      } else if (/maxthon/i.test(ua)) {
        result = {
          name: 'Maxthon',
          maxthon: t,
          version: getFirstMatch(/maxthon\/(\d+(\.\d+)?)/i)
        };
      } else if (/chrom.+? edge/i.test(ua)) {
        result = {
          name: 'Edge',
          vendor: 'Microsoft',
          msie: t,
          edge: t,
          msedge: t,
          version: edgeVersion
        };
      } else if (/msie|trident/i.test(ua)) {
        result = {
          name: 'Internet Explorer',
          vendor: 'Microsoft',
          msie: t,
          version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
        };
      } else if (/chrome|crios|crmo/i.test(ua)) {
        result = {
          name: 'Chrome',
          vendor: 'Google',
          chrome: t,
          version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
        };
      } else if (iosdevice) {
        result = {
          name: iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod',
          vendor: 'Apple'
        };

        if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (/sailfish/i.test(ua)) {
        result = {
          name: 'Sailfish',
          sailfish: t,
          version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
        };
      } else if (/seamonkey\//i.test(ua)) {
        result = {
          name: 'SeaMonkey',
          seamonkey: t,
          version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
        };
      } else if (/firefox|iceweasel/i.test(ua)) {
        result = {
          name: 'Firefox',
          vendor: 'Mozilla',
          firefox: t,
          version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
        };
        if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
          result.firefoxos = t;
        }
      } else if (/silk/i.test(ua)) {
        result = {
          name: 'Silk',
          vendor: 'Amazon',
          silk: t,
          version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
        };
      } else if (android) {
        result = {
          name: 'Android',
          vendor: 'Google',
          version: versionIdentifier
        };
      } else if (/phantom/i.test(ua)) {
        result = {
          name: 'PhantomJS',
          phantom: t,
          version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
        };
      } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
        result = {
          name: 'BlackBerry',
          blackberry: t,
          version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
        };
      } else if (/(web|hpw)os/i.test(ua)) {
        result = {
          name: 'WebOS',
          webos: t,
          version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
        };

        if (/touchpad\//i.test(ua)) {
          result.touchpad = t;
        }
      } else if (/bada/i.test(ua)) {
        result = {
          name: 'Bada',
          bada: t,
          version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
        };
      } else if (/tizen/i.test(ua)) {
        result = {
          name: 'Tizen',
          tizen: t,
          version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
        };
      } else if (/safari/i.test(ua)) {
        result = {
          name: 'Safari',
          vendor: 'Apple',
          safari: t,
          version: versionIdentifier
        };
      } else {
        result = {};
      }


      if (!result.msedge && /(apple)?webkit/i.test(ua)) {
        if (/(apple)?webkit\/537\.36/i.test(ua)) {
          result.name = result.name || "Blink"
          result.blink = t
        } else {
          result.name = result.name || "Webkit"
          result.webkit = t
        }
        if (!result.version && versionIdentifier) {
          result.version = versionIdentifier
        }
      } else if (!result.opera && /gecko\//i.test(ua)) {
        result.name = result.name || "Gecko"
        result.gecko = t
        result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
      }


      if (!result.msedge && (android || result.silk)) {
        result.android = t
      } else if (iosdevice) {
        result[iosdevice] = t
        result.ios = t
      } else if (mac) {
        result.mac = t
      } else if (windows) {
        result.windows = t
      } else if (linux) {
        result.linux = t
      }


      let osVersion = '';
      if (result.windowsphone) {
        osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
      } else if (iosdevice) {
        osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
        osVersion = osVersion.replace(/[_\s]/g, '.');
      } else if (android) {
        osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
      } else if (result.webos) {
        osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
      } else if (result.blackberry) {
        osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
      } else if (result.bada) {
        osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
      } else if (result.tizen) {
        osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
      }
      if (osVersion) {
        result.osversion = osVersion;
      }


      let osMajorVersion = osVersion.split('.')[0];
      if (tablet || iosdevice == 'ipad' || result.silk || (android && (osMajorVersion == 3 || (osMajorVersion == 4 && !mobile)))) {
        result.tablet = t;
      } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android ||
        result.blackberry || result.webos || result.bada) {
        result.mobile = t;
      }

      return result;
    }


    return detect(ua);

  }



  _boaBrowserSystemCheck() {


    let p = this.settings.platform || this.settings.ua;
    let boaBrowserObject = this.boaBrowserObject;

    if (p.indexOf("Win") > -1) {
      boaBrowserObject.win = true;
    } else if (p.indexOf("Mac") > -1) {
      boaBrowserObject.mac = true;
    } else if (p.indexOf("X11") > -1 || p.indexOf("Linux") > -1) {
      boaBrowserObject.linux = true;
    } else {
      boaBrowserObject.win = true; 
    }


    boaBrowserObject.desktop = (!boaBrowserObject.mobile && !
      boaBrowserObject.tablet && (boaBrowserObject.win ||
        boaBrowserObject.mac || boaBrowserObject.linux));


    if (boaBrowserObject.win) {
      if (/Win(?:dows )?([^do]{2})\s?(\d+\.\d+)?/.test(this.settings.ua)) {
        if (RegExp["$1"] == "NT") {
          switch (RegExp["$2"]) {
            case "5.0":
              boaBrowserObject.osversion = "2000";
              break;
            case "5.1":
              boaBrowserObject.osversion = "XP";
              break;
            case "6.0":
              boaBrowserObject.osversion = "Vista";
              break;
            case "6.1":
              boaBrowserObject.osversion = "Windows 7";
              break;
            case "6.2":
              boaBrowserObject.osversion = "Windows 8";
              break;
            case "10.0":
              boaBrowserObject.osversion = "Windows 10";
              break;
            default:
              boaBrowserObject.osversion = "";
              break;
          }

        } else if (RegExp["$1"] == "Ph") {
          if (/Windows Phone OS.?(\d+\.\d+)?/.test(this.settings.ua)) {
            boaBrowserObject.osversion = RegExp["$1"];
          }
        } else if (RegExp["$1"] == "9x") {
          boaBrowserObject.osversion = "ME";
        } else {
          boaBrowserObject.osversion = RegExp["$1"];
        }
      }
    }

    return boaBrowserObject;
  }


  _boaBrowserPluginCheck() {

    let plugins = {};


    function hasPlugin(name) {
      name = name.toLowerCase();
      for (let i = 0; i < navigator.plugins.length; i++) {
        if (navigator.plugins[i].name.toLowerCase().indexOf(name) > -1) {
          return true;
        }
      }
      return false;
    }


    function hasIEPlugin(name) {
      try {
        new ActiveXObject(name);
        return true;
      } catch (ex) {
        return false;
      }
    }


    function hasFlash() {
      var r = hasPlugin("Flash");
      if (!r) {
        r = hasIEPlugin("ShockwaveFlash.ShockwaveFlash");
      }
      return r;
    }


    function hasQuickTime() {
      var r = hasPlugin("QuickTime");
      if (!r) {
        r = hasIEPlugin("QuickTime.QuickTime");
      }
      return r;
    }

    try {
      plugins.flash = hasFlash();
      plugins.quicktime = hasQuickTime();
      this.boaBrowserObject.plugins = plugins;
    } catch (err) { }


    return;
  }



  _boaBrowserUpdateMessageData() {

    this._debug('start _boaBrowserUpdateMessageData');


    if (!this.settings.useAjax ||
      (this.settings.isLocal &&
        (window.location.protocol == "file:" || !this.settings.testMode)
      )) {
      this._boaBrowserProcessRules();
      this.boaBrowserObject.loaded = true;
      spartaEventsUtility.pub(EVENTS.LOADED);
      return;
    }

    $.ajax({
      type: "GET",


      url: "/globals/utilities/browser-support/1.0.0/browserData.json",
      dataType: "script",
      cache: true,

      success: function (data, textStatus, jqxhr) {
        try {

          if (typeof boaBrowserSupportCMS !== "undefined" && boaBrowserSupportCMS.content) {


            this.boaBrowserObject.browserSupport = boaBrowserSupportCMS;


            this.boaBrowserObject.browserSupport.source = "cms";





            this._boaBrowserProcessRules();


            this._boaBrowserSetSessionStorage();

            this.boaBrowserObject.loaded = true;
            $document.trigger('spartaBrowserObjectLoaded');
          }

        } catch (e) {
          this._debug('browserDetect:_boaBrowserUpdateMessageData: ajax error: ' + e);
        }
      }
    });
  }


  _boaBrowserProcessRules() {
    this._debug('browserDetect: begin _boaBrowserProcessRules');


    let userMsg = this.boaBrowserObject.browserSupport.rules(this.boaBrowserObject);


    if (userMsg && userMsg.rule) {
      this.boaBrowserObject.userNotice = userMsg;
    }

    this._boaBrowserShowMessage();
  }



  _checkShowMessage() {
    try {

      if (this.settings.isLocal && !this.settings.testMode) {
        this._debug("Working in local module / localhost, suppress browser alert");
        return false;
      }

    } catch (e) {
      this._debug('browserDetect: _checkShowMessage error: ' + e);
    }

    if (!this.settings.showMessage || this.settings.boaBrowserShowNoticeCookie === "false" ||
      (typeof boaBrowserShowNotice !== "undefined" && boaBrowserShowNotice === false) ||
      spartaGlobalFunctions.getUrlParam("boaBrowserShowNotice") === "false") {
      return false;
    }

    this._debug('_checkShowMessage OK to show message.');
    return true;
  }


  _boaBrowserShowMessage() {
    this._debug('in _boaBrowserShowMessage');



    this.settings.showMessage = this._checkShowMessage();

    if (!this.settings.showMessage) {
      this._debug('showMessage is false');
      return;
    }

    let userMsg, closeText, msg, style, btnText, link,
      b = this.boaBrowserObject,
      currentBrowserInfo = "",
      loc = window.location.hostname;

    b.url = b.browserSupport.url || {};

    if (/(cert|qa|sit).*\.bankofamerica\.com$/.test(loc)) {
      link = b.browserSupport.url.cert;
    } else if (/(dev).*\.bankofamerica\.com$/.test(loc)) {
      link = b.browserSupport.url.dev;
    } else {
      link = b.browserSupport.url.prod;
    }
    link += b.userNotice.link;


    if (b.userNotice && b.userNotice.rule && b.userNotice.en) {
      let lang = (spartaStoreUtility.getData("lang") === "en-us" ? "en" : "es");

      if (b.name.length > 0 && b.version.length > 0) {
        currentBrowserInfo = b.browserSupport.content.misc[lang].current + ' ' + b.name + ' ' + b.version + '<br>';
      }
      style = b.userNotice.style;
      msg = b.userNotice[lang].msg;
      btnText = b.userNotice[lang].btnText;
      closeText = b.browserSupport.content.misc[lang].closeText;

      let notice = b.browserSupport.template.replace(
        '{currentBrowserInfo}', "").replace(
        '{style}', style).replace(
        '{msg}', msg).replace(
        '{link}', link).replace(
        '{btnText}', btnText).replace(
        '{closeText}', closeText).replace(
        '{msg-icon-sprite-fsd-source}', window.spaParams.global[lang].sprites.message);

      $('[data-sparta-container]:first').find('div:first').before(notice);


      $('#browserUpgradeNoticeBarClose').click(
        function () {
          $('#browserUpgradeNoticeBar').hide();
          spartaGlobalFunctions.setSpartaCookie("boaBrowserShowNotice", false);
        });
    }
  }


  _boaBrowserGetSessionStorage() {
    if (this.settings.useSessionStorage && window.sessionStorage.getItem('settings')) {
      this.settings = JSON.parse(window.sessionStorage.getItem('settings'));

      if (this.settings.boaBrowserObject) {
        return this.settings.boaBrowserObject;
      }
    }
    return false;
  }


  _boaBrowserGetDefaultObj() {
    let boaBrowserDefault = {
      "loaded": false,
      "ua": this.settings.ua,
      "debug": this.settings.debug,

      "a": false,
      "c": false,
      "x": false,


      "msie": false,
      "edge": false,
      "chrome": false,
      "firefox": false,
      "safari": false,
      "opera": false,
      "android": false,
      "ios": false,
      "iosdevice": false,
      "ipad": false,
      "iphone": false,
      "ipod": false,
      "blackberry": false,
      "silk": false,
      "crawler": false,


      "name": "",
      "vendor": "",
      "version": "",
      "webkit": false,
      "gecko": false,


      "tablet": false,
      "mobile": false,
      "desktop": false,
      "win": false,
      "mac": false,
      "linux": false,
      "osversion": "",
      "windowsphone": false,
      "plugins": {
        "flash": false,
        "quicktime": false
      },


      "userNotice": {
        "rule": "",
        "en": {
          "msg": ""
        },
        "es": {
          "msg": ""
        },
        "link": ""
      },


      "browserSupport": {
        "source": "js",
        "showMessage": true,
        "url": {
          "prod": "https://www.bankofamerica.com",
          "cert": "https://www-cert1.ecnp.bankofamerica.com",
          "dev": "https://www-dev3.ecnp.bankofamerica.com"
        },
        "content": {
          "unsupportedBlocked": {
            "rule": "unsupportedBlocked",
            "style": "boa-browser-1 hide-close",
            "en": {
              "msg": "You are using an unsupported browser version.",
              "btnText": "Learn more or update your browser."
            },
            "es": {
              "msg": "Est&aacute; usando una versi&oacute;n de navegador incompatible.",
              "btnText": "M&aacute;s informaci&oacute;n sobre c&oacute;mo actualizar su navegador."
            },
            "link": "/information/supported-browsers/?m=unsupportedBlocked"
          },
          "unsupportedBrowserType": {
            "rule": "unsupportedBrowserType",
            "style": "boa-browser-1",
            "en": {
              "msg": "You are using an unsupported browser version.",
              "btnText": "Learn more or update your browser."
            },
            "es": {
              "msg": "Est&aacute; usando una versi&oacute;n de navegador incompatible.",
              "btnText": "M&aacute;s informaci&oacute;n sobre c&oacute;mo actualizar su navegador."
            },
            "link": "/information/supported-browsers/?m=unsupportedBrowserType"
          },
          "unsupportedEndOfLife": {
            "rule": "unsupportedEndOfLife",
            "style": "boa-browser-1",
            "en": {
              "msg": "You are using an unsupported browser version.",
              "btnText": "Learn more or update your browser."
            },
            "es": {
              "msg": "Est&aacute; usando una versi&oacute;n de navegador incompatible.",
              "btnText": "M&aacute;s informaci&oacute;n sobre c&oacute;mo actualizar su navegador."
            },
            "link": "/information/supported-browsers/?m=unsupportedEOL"
          },
          "supportedUpgradeVersion": {
            "rule": "supportedUpgradeVersion",
            "style": "boa-browser-2",
            "en": {
              "msg": "You are using an unsupported browser version.",
              "btnText": "Learn more or update your browser."
            },
            "es": {
              "msg": "Est&aacute; usando una versi&oacute;n de navegador incompatible.",
              "btnText": "M&aacute;s informaci&oacute;n sobre c&oacute;mo actualizar su navegador."
            },
            "link": "/information/supported-browsers/?m=supportedUpgradeVersion"
          },
          "supportedBrowser": {
            "rule": "supportedBrowser"
          },
          "mobileBrowser": {
            "rule": "mobileBrowser"
          },
          "misc": {
            "en": {
              "current": "Browser in use:",
              "closeText": "close"
            },
            "es": {
              "current": "Navegador en uso:",
              "closeText": "cerrar"
            }
          }
        },
        "rules": function (b) {

          var userMsg;

          if (b.mobile || b.tablet || b.crawler) {


            userMsg = b.browserSupport.content.mobileBrowser;


          } else if ((b.msie && b.version <= VERSIONS.BLOCKED_IE) || (b.firefox && b.version <= VERSIONS.BLOCKED_FF)) {

            userMsg = b.browserSupport.content.unsupportedBlocked;

          } else if (!(b.win && b.msie) && !b.chrome && !(b.win && b.firefox) && !(b.mac && b.safari)) {

            userMsg = b.browserSupport.content.unsupportedBrowserType;


          } else if (
            (b.msie && b.version <= VERSIONS.EOL_IE) || 
            (b.chrome && b.version <= VERSIONS.EOL_CHROME) || 
            (b.firefox && b.version <= VERSIONS.EOL_FF) || 
            (b.safari && b.version <= VERSIONS.EOL_SAFARI)) { 

            userMsg = b.browserSupport.content.unsupportedEndOfLife;










          } else {
            userMsg = b.browserSupport.content.supportedBrowser;
          }
          return userMsg;
        },
        "template": "<div id='browserUpgradeNoticeBar' class='{style}'>" +
        "<div class='row'>" +
        "<div class='column small-1 medium-1 text-right' style='padding-right: 0'><div class='msg-icon-sprite-fsd'><span class='ada-hidden'>warning-icon</span></div></div>" +
        "<div class='column small-10 medium-10' style='padding-left: 0.2rem'>" +
        "<div class='msg-container'><span class='msg-text'>{currentBrowserInfo}{msg}<a target='_blank' href='{link}' name='boaBrowserInfoBtn' id='boaBrowserInfoBtn' class='browser-upgrade-now'>{btnText}</a></span>" +
        "</div></div>" +
        "<div class='column small-1' style='line-height: 18px;'><a id='browserUpgradeNoticeBarClose' class='spa-ui-layer-close' style='top:0; left:0;' href='javascript:void(0);'><span class='close-text ada-hidden'>{closeText} browser upgrade notice</span> <span class='spa-close-x' aria-hidden='true'>×</span></a></div>" +
        "</div><style>#browserUpgradeNoticeBar {padding: 10px 0;} #browserUpgradeNoticeBarClose .close-fsd {display: inline-block; position: relative; top: 4px;}  #browserUpgradeNoticeBar.hide-close #browserUpgradeNoticeBarClose {display:none;} #browserUpgradeNoticeBar .msg-container {padding-top: 5px; font-size: 14px;} #browserUpgradeNoticeBar .msg-icon-sprite-fsd { background: url('{msg-icon-sprite-fsd-source}') no-repeat scroll 0 0 transparent; display: inline-block; position: relative; top: 4px; left: -10px;} #browserUpgradeNoticeBar .msg-text {display: inline-block; position: relative; top: -2px;} #browserUpgradeNoticeBar .browser-upgrade-now {margin-left: 10px;} #browserUpgradeNoticeBar.boa-browser-1 { background-color: #FFF4F9; border-bottom: 1px solid #E31838; } #browserUpgradeNoticeBar.boa-browser-1 .msg-icon-sprite-fsd {background-position: -70px 0;height:24px;width:24px;} #browserUpgradeNoticeBar.boa-browser-2 { background-color: #FFF5D7; border-bottom: 1px solid #FC7800; } #browserUpgradeNoticeBar.boa-browser-2 .msg-icon-sprite-fsd {background-position: -70px -240px;height:24px;width:24px;}</style></div>"
      }
    };

    return boaBrowserDefault;
  }


  addBrowserClasses() {

    let uaClasses = [];
    let uaClassesStr = "";
    let classPrefix = "spa-ua-";
    let b = this.boaBrowserObject || {};


    switch (true) {
      case b.desktop:
        uaClasses.push("desktop");
        break;
      case b.tablet:
        uaClasses.push("tablet");
        break;
      case b.mobile:
        uaClasses.push("mobile");
        break;
    }


    switch (true) {
      case b.msie:
        uaClasses.push("browser-msie");
        break;
      case b.firefox:
        uaClasses.push("browser-firefox");
        break;
      case b.chrome:
        uaClasses.push("browser-chrome");
        break;
      case b.safari:
        uaClasses.push("browser-safari");
        break;
      case b.opera:
        uaClasses.push("browser-opera");
        break;
      case b.silk:
        uaClasses.push("browser-silk");
        break;
      default:
        uaClasses.push("browser-other");
    }
    if (b.version) {
      uaClasses.push("browser-version-" + parseInt(b.version));
    }


    switch (true) {
      case b.mac:
        uaClasses.push("system-mac");
        break;
      case b.ios:
        uaClasses.push("system-ios");

        switch (true) {

          case b.ipad:
            uaClasses.push("system-ipad");
            break;
          case b.iphone:
            uaClasses.push("system-iphone");
            break;
          case b.ipod:
            uaClasses.push("system-ipod");
            break;
        }
        break;
      case b.android:
        uaClasses.push("system-android");
        break;
      case b.windowsphone:
        uaClasses.push("system-windowsphone");
        break;
      case b.blackberry:
        uaClasses.push("system-blackberry");
        break;
      case b.win:
        uaClasses.push("system-win");
        break;
      default:
        uaClasses.push("system-other");
    }

    for (i = 0; i < uaClasses.length; i++) {
      uaClassesStr += " " + classPrefix + uaClasses[i];
    }

    $('html').addClass(uaClassesStr);
  }
}

export default new SpartaBrowserSupportUtility();
